import React, {useState} from 'react';
import SideNavigation from "../../components/SideNavigation";
import {Outlet, useSearchParams} from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2";
import wordpressMessageEnum from "src/enum/wordpressMessageEnum";
import {Alert, Button, useMediaQuery, useTheme} from "@mui/material";
import {useConfirm} from "material-ui-confirm";
import useAuth from "src/hooks/use-auth";
import {SwapHoriz} from "@mui/icons-material";
import Box from "@mui/material/Box";

const PageLayout = ({children}) => {
  const [ searchParams ] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [messageShown, setMessageShown] = useState(false);
  const confirm = useConfirm();
  const { onLogout } = useAuth();

  const showMessage = () => {
    if (messageShown) {
      return;
    }

    if (!searchParams) {
      return;
    }

    switch (searchParams.get('bericht')) {
      case wordpressMessageEnum.THANK_YOU_FOR_PARTICIPATING:
        confirm({
          title: 'Bedankt voor de deelname',
          description: `Bedankt voor uw deelname aan dit onderzoek. Uw saldo is bijgewerkt.`,
          confirmationText: 'Sluiten',
          hideCancelButton: true,
        });
        break;
      case wordpressMessageEnum.NOT_A_PART_OF_TARGET_AUDIENCE:
        confirm({
          title: 'U behoort niet tot de doelgroep',
          description: 'Helaas behoort u niet tot onze doelgroep en kunt u niet deelnemen aan dit onderzoek. Bij vragen mag u ons altijd een email sturen.',
          confirmationText: 'Sluiten',
          hideCancelButton: true,
        });
        break;
      default:
        break;
    }
    setMessageShown(true);
  }

  if (!messageShown) {
    showMessage();
  }

  const impersonatedUser = localStorage.getItem('senso-impersonate-user');

  const stopImpersonation = () => {
    const rootElement = document.querySelector('#senso-account-root');
    let portalUrl = rootElement.getAttribute('data-portal-url');
    const userUrl = portalUrl.concat('/#/gebruikers');

    onLogout();

    window.location.href = userUrl;
  }

  const impersonatedAlert = (
    <Alert
      icon={<SwapHoriz />}
      severity="info"
      action={<Button onClick={stopImpersonation} size="small">Stoppen</Button>}
    >
      Je neemt momenteel de gebruiker {impersonatedUser} over.
    </Alert>
  );

  if (!isMobile) {
    return (
      <Grid2 container spacing={6}>
        <Box display="flex" justifyContent="center" width="100%">
          { impersonatedUser && impersonatedAlert}
        </Box>

        <Grid2 xs={12} md={8}>
          {children ?? <Outlet />}
        </Grid2>
        <Grid2 xs={12} md={4}>
          <SideNavigation />
        </Grid2>
      </Grid2>
    );
  }

  return (
    <Grid2 container spacing={6}>
      <Box display="flex" justifyContent="center" width="100%">
        { impersonatedUser && impersonatedAlert}
      </Box>

      <Grid2 xs={12} md={4}>
        <SideNavigation isMobile />
      </Grid2>
      <Grid2 xs={12} md={8}>
        {children ?? <Outlet />}
      </Grid2>
    </Grid2>
  );
}

export default PageLayout;

PageLayout.propTypes = {}

PageLayout.defaultProps = {}